import * as React from 'react';
import GamesCategoryNav from '@/components/shared/games-category-nav/GamesCategoryNav';
import HeaderBannerCarousel from '@/components/shared/banners/HeaderBannerCarousel';
import { useSelector } from 'react-redux';
import { selectHeaderBanners } from '@/store/cms/header-banners/selectors';

const ProviderGamesLayout = ({
  provider,
  children,
}: {
  provider: string;
  children: React.ReactNode;
}) => {
  const headerBanners = useSelector(selectHeaderBanners);
  const filteredHeaderBanners = headerBanners.filter(banner => banner.pages?.includes(provider));
  return (
    <div className="relative">
      <HeaderBannerCarousel
        headerBanners={filteredHeaderBanners.length > 0 ? filteredHeaderBanners : headerBanners}
      />

      <GamesCategoryNav />
      {children}
    </div>
  );
};

export default ProviderGamesLayout;
